import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  position: fixed;
  height: 35px;
  width: 130px;
  border-radius: 8px;
  border: 2px solid #fff;
  top: 127px;
  right: 10px;
  z-index: 5;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  transition: height 0s, opacity 0.2s ease-in-out;
  background-color: #f2008c;
  box-shadow: 0 0 10px #d4d4d4;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.fadeIn {
    animation-name: fadeIn;
  }

  &.animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  ${mediaMaxWidth.tablet`
    bottom: 10px;
    top: unset;
    left: 10px;
  `}
`;

export const Text = styled.div`
  font-size: 0.9em;
  font-weight: 700;
  color: #fff;
`;

export const Spinner = styled.img`
  width: 14px;
  height: 14px;
  align-self: center;
`;
